const Style = {

  //user: 'absolute top-1/2 -translate-y-3/4 right-3 z-10',
  //user: 'text-center -translate-x-1/2',
  user: 'text-center',
  name: 'float-right opacity-80 text-xs font-normal -mt-10 -mr-4 -mb-4',

} 

export default Style;